import { MRT_ColumnDef } from "material-react-table";
import { useMemo } from "react";
import { IconButton, Tooltip } from "@mui/material";
import { Delete } from "@mui/icons-material";
import CustomCantidadInput from "../components/ui/CustomCantidadInput";
import { AlertSeverityEnum, MaterialTransferido } from "../interfaces";
import { useCargarSeriesProductos } from "@/store/erp/productos/useCargarSeriesProductos.store";
import { useUiStore } from "@/store/ui";
import { cellStockProductoMetros } from "../utils";
import ButtonSeries from "../components/ui/ButtonSeries/ButtonSeries";

export const useTableCoumnsEgresoInventarioSerie = () => {
  const handleActualizarProducto = useCargarSeriesProductos(s => s.handleActualizarProducto)
  const handleEliminarProdcuto = useCargarSeriesProductos(s => s.handleEliminarProducto)
  const setOpenModalSeries = useCargarSeriesProductos(s => s.setOpenModalSeries)
  const setAuxRow = useCargarSeriesProductos(s => s.setAuxRow)
  const setAlert = useUiStore(s => s.setAlert)
  const columnsInfoProducto = useMemo<MRT_ColumnDef<MaterialTransferido>[]>(() => [
    /* {
      accessorKey: 'codigo',
      header: 'Codigo'
    }, */
    {
      accessorKey: 'producto_data.stock_actual',
      header: "Stock Ubicación",
      Cell: ({ row }) => {
        return cellStockProductoMetros(row.original)
      }
    },
    {
      accessorKey: 'producto_data.descripcion',
      header: 'Descripción'
    },
    {
      accessorKey: 'producto_data.categoria_producto',
      header: 'Categoria '
    },
    /* {
      accessorKey: 'producto_data.subcategoria_producto',
      header: 'Subcategoria'
    } */
  ], [])

  const columnsEgresoInventario = useMemo<MRT_ColumnDef<MaterialTransferido>[]>(() => [
    {
      accessorKey: 'accion',
      header: 'Accion',
      size: 100,
      Cell: ({ row }) => {
        return (
          <Tooltip title="Eliminar">
            <IconButton
              onClick={() => {
                handleEliminarProdcuto(row.original.id)
              }}
            >
              <Delete color="error" />
            </IconButton>

          </Tooltip>

        )
      }
    },
    {
      accessorKey: 'cantidad',
      header: 'Cant. A Despachar',
      size: 190,
      Cell: ({ row }) => (
        <CustomCantidadInput<MaterialTransferido>
          value={row.original.cantidad}
          handleValue={(value) => {
            handleActualizarProducto(row.original.id, {
              ...row.original,
              cantidad: value,
            })
          }}
          row={row}
        />
      )
    },
    /* {
      accessorKey: 'contiene_serie',
      header: 'Contiene',
      size: 100,
      Cell: ({ row }) => {
        return (
          <Checkbox
            value={row.original.contiene_serie ?? false}
            inputProps={{ 'aria-label': 'controlled' }}
            checked={row.original.contiene_serie ?? false}
            onChange={e => {
              handleActualizarProducto(row.original.id, {
                ...row.original,
                contiene_serie: e.target.checked
              })
            }
            }
          />
        )
      }

    }, */
    {
      accessorKey: 'series',
      header: 'Series',
      size: 100,
      enableColumnFilter: false,
      enableSorting: false,
      Cell: ({ row }) => {
        const original = row.original

        const {
          contiene_serie
        } = original

        return (
          <ButtonSeries
            disabled={!contiene_serie}
            onClick={() => {
              if (!contiene_serie)
                return setAlert(true, 'Seleccionar la opcion de habilitar serie.', AlertSeverityEnum.info);

              setOpenModalSeries(true);
              setAuxRow(row.original)
            }}
          />
        )
      }
    },
    ...columnsInfoProducto
  ], [])
  return {
    columnsEgresoInventario
  }
}
export default useTableCoumnsEgresoInventarioSerie;